import Container from '@material-ui/core/Container';
import { ComponentProps } from 'react';

import InspectionBanner from 'src/components/InspectionBanner';
import InspectionCheckList from 'src/components/InspectionCheckList';
import IconSuccess from 'src/components/InspectionCheckList/images/IconSuccess.svg';
import { SEOCopyParagraph } from 'src/components/SEOCopyParagraph/SEOCopyParagraph';
import { GetInspectionChecklistQuery } from 'src/data/Contentful/ContentfulGetInspectionChecklist';
import useFillCMSData from 'src/hooks/useFillCMSData';

import inspectionPointsHelper from '../../utils/300PointsHelper';
import useStyles from './300PointInspection.style';

const Page300PointInspection = ({ checklistData }: { checklistData: GetInspectionChecklistQuery }) => {
  const classes = useStyles();

  const { cmsData, cmsAssets, cmsNavigations, cmsEntries } = useFillCMSData();
  const helperArgs = [cmsData, cmsAssets, cmsNavigations, cmsEntries];

  return (
    <>
      <InspectionBanner {...inspectionPointsHelper.getPageHeaderProps(...helperArgs)} />
      <Container>
        {/* @ts-ignore */}
        <InspectionCheckList {...checklistDataToComponentProps(checklistData)} />
      </Container>
      <Container className={classes.seoParagraph}>
        <SEOCopyParagraph />
      </Container>
    </>
  );
};

const checklistDataToComponentProps = (
  data: GetInspectionChecklistQuery,
): ComponentProps<typeof InspectionCheckList> => {
  const checklist: ComponentProps<typeof InspectionCheckList>['data'] = [];

  data.componentPointInspection.allInspectionsCollection.items.forEach((element) => {
    // Look if there is already a checklist category created
    const index = checklist.findIndex((item) => item.question === element.category);
    if (index === -1) {
      checklist.push({
        question: element.category,
        icon: element.icon.url,
        listDataChildren: [
          {
            answer: element.name,
            checkAnswer: '',
            iconSuccess: IconSuccess,
          },
        ],
      });
    } else {
      checklist[index].listDataChildren.push({
        answer: element.name,
        checkAnswer: '',
        iconSuccess: IconSuccess,
      });
    }
  });

  return {
    title: data.componentPointInspection.headline,
    data: checklist,
  };
};

export default Page300PointInspection;
